
import  axios  from 'axios';
import {CLEAR_A_TOWJOB_ERROR_MESSAGE, clearTowErrorMsgInStore} from "../towjob/actions";
import AppUtils from "../../../utils/AppUtils";
import {loadStoragelotDataInStore} from "../storagelot/actions";


export const LOAD_POLICE_DATA = 'police/LOAD_POLICE_DATA';
export const DELETE_A_POLICE = 'police/DELETE_A_POLICE';
export const SAVE_A_POLICE = 'police/SAVE_A_POLICE';
export const UPDATE_A_POLICE = 'police/UPDATE_A_POLICE';
export const CLEAR_A_POLICE_ERROR_MESSAGE = 'police/CLEAR_A_POLICE_ERROR_MESSAGE';


export function clearPoliceErrorMsgInStore(){
    return {
        type: CLEAR_A_POLICE_ERROR_MESSAGE,
        
    }
}
export function loadPoliceDataInStore(argPoliceDataArray) {
    return {
        type: LOAD_POLICE_DATA,
        policeData:argPoliceDataArray
    }
}
export function deleteAPoliceInStore(argDeleteResponse, argErrorMsg) {
    return {
        type: DELETE_A_POLICE,
        deletePoliceResponse:argDeleteResponse,
        errorMsg:argErrorMsg
    }
}

export function saveAPoliceDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: SAVE_A_POLICE,
        savePoliceResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

export function updateAPoliceDataInStore(argSaveResponse , argErrorMsg) {
    return {
        type: UPDATE_A_POLICE,
        updatePoliceResponse:argSaveResponse,
        errorMsg:argErrorMsg
    }
}

/********************* End of InStore calls **************************/

export function addPoliceToPolicesArray(argPolice ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempPolicesArray=[] ;
        tempPolicesArray = Object.assign(tempPolicesArray,state.police.policeArray);
        //removig the match element with the matching id.
        let newPolicesArray = tempPolicesArray.filter(element => { return element.id !== argPolice.id });
        //adding to the top of the array.
        newPolicesArray.unshift(argPolice);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadPoliceDataInStore(newPolicesArray));
        
    }//end of return
}


export function deletePoliceFromPolicesArray(argPoliceId ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempPolicesArray=[] ;
        tempPolicesArray = Object.assign(tempPolicesArray,state.police.policeArray);
        //removig the match element with the matching id.
        let newArray = tempPolicesArray.filter(element => { return element.id != argPoliceId });
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadPoliceDataInStore(newArray));
    }//end of return
}

export function updatePoliceInPolicesArray(argPolice ) {
    return (dispatch, getState) => {
        const state = getState();
        let tempPolicesArray=[] ;
        tempPolicesArray = Object.assign(tempPolicesArray,state.police.policeArray);
        //rempoving the item from the array and then add the updated one to the array array.
        let newArray = tempPolicesArray.filter(element => { return element.id != argPolice.id });
        //adding to the top of the array.
        newArray.unshift(argPolice);
        //tempTowJobsArray.concat(argTowJob);
        dispatch(loadPoliceDataInStore(newArray));
    }//end of return
}



//****************************************
//Below is for update a Stream
//****************************************
export function clearPoliceErrorMsg(){
    return (dispatch, getState) => {
        dispatch(clearPoliceErrorMsgInStore());
    }
}

export function updateAPolice(argURL, argCamera, argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        updateAPoliceOnServer(argURL, argCamera, argCompanyId ,state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(updateAPoliceDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));
            dispatch(loadPoliceData(argURL, argCompanyId));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            console.log("I had an error updating a police" + errorObj.statusText + errorObj.status);
            dispatch(updateAPoliceDataInStore({}, errorObj));
        });
    }//end of return
}


function updateAPoliceOnServer( argURL, argCamera, argCompanyId ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPutsForUpdateAPolice(argURL, argCamera, argCompanyId ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                console.log("Farshid some error occured on saving a StorageLot " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPutsForUpdateAPolice(argURL, argPolice,argCompanyId ,argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/police" ;
    console.log(" on posting a police the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.put(baseUrl,argPolice, {headers: {"Authorization" : `Bearer ${argIdToken}`}}  ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for save a Stream
//****************************************
export function saveAPolice(argURL, argCamera,argCompanyId) {
    return (dispatch, getState) => {
        const state = getState();
        saveAPoliceOnServer(argURL, argCamera,argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(saveResponse){

            dispatch(saveAPoliceDataInStore(saveResponse.data, {"status":saveResponse.status, "statusText":saveResponse.statusText}));
            dispatch(loadPoliceData(argURL, argCompanyId));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            console.log("I had an error saving a police" + errorObj.statusText + errorObj.status);
            dispatch(saveAPoliceDataInStore({}, errorObj));
        });
    }//end of return
}


function saveAPoliceOnServer( argURL, argCamera, argCompanyId  ,argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfPostsForSaveAPolice(argURL, argCamera, argCompanyId  ,argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on saving a police " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfPostsForSaveAPolice(argURL, argCamera, argCompanyId ,argIdToken, argUserId){
    /*
     I build something like this :
     http://localhost:4567/companys
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/police";
    console.log(" on posting a police the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.post(baseUrl,argCamera ,{headers: {"Authorization" : `Bearer ${argIdToken}`}} ));
    }
    return arrayOfGets;
}


//****************************************
//Below is for delete a company
//****************************************
export function deleteAPolice(argURL, argCameraId, argCompanyId ) {
    return (dispatch, getState) => {
        const state = getState();
        deleteAPoliceOnServer(argURL, argCameraId,argCompanyId , state.login.loginData.idToken, state.user.saveUserResp.id).then(function(deleteResponse){

            dispatch(deleteAPoliceInStore(deleteResponse.data, {"status":deleteResponse.status, "statusText":deleteResponse.statusText}));
            dispatch(loadPoliceData(argURL, argCompanyId));

        }, function(err){
            var errorObj = AppUtils.getErroStatusAndText(err);
            //console.log("I had an error gettting Stream Data2" + err);
            dispatch(deleteAPoliceInStore({}, errorObj));
        });
    }//end of return
}


function deleteAPoliceOnServer( argURL, argStreamId,argCompanyId,  argIdToken, argUserId){

    var returnPromise = new Promise(function(resolve, reject){



        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfDeletesForDeleteAPolice(argURL, argCompanyId ,argStreamId,  argIdToken, argUserId)).then(function(responses){
                resolve(responses[0]);
            }, function(err) {
                //console.log("Farshid some error occured on deleteing a Police " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}



function getArrayOfDeletesForDeleteAPolice(argURL, argRealCompanyId, argStorageId, argIdToken, argUserId ){
    /*
     I build something like this :
     http://localhost:4567/cameras
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies"+"/"+argRealCompanyId+"/police/"+argStorageId;
    console.log(" on deleteing a Police the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.delete(baseUrl, {headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}


//Get list of companys

export function loadPoliceData(argURL, argCompanyId) {
    if((argCompanyId !== null)&&( argCompanyId !== undefined) ) {
        return (dispatch, getState) => {
            const state = getState();
            getListOfPolice(argURL, argCompanyId, state.login.loginData.idToken, state.user.saveUserResp.id).then(function (companysList) {
                
                dispatch(loadPoliceDataInStore(companysList));
                
            }, function (err) {
                console.log("I had an error gettting Farms Data2" + err);
            });
        }//end of return
    }
}

function getArrayOfGetsForListOfPolice(argURL,argCompanyId ,argIdToken, argUserId  ){
    /*
     I build something like this :
     http://localhost:4567/company
     */

    let baseUrl = argURL+"users/"+ argUserId+"/companies/"+argCompanyId+"/police";
    console.log(" on getting list of Police  the URL is " + baseUrl );

    var arrayOfGets = [];
    if(argURL != null) {
        arrayOfGets.push(axios.get(baseUrl,{headers: {"Authorization" : `Bearer ${argIdToken}`}}));
    }
    return arrayOfGets;
}

function getListOfPolice( argURL ,argCompanyId, argIdToken, argUserId ){

    var returnPromise = new Promise(function(resolve, reject){

        var arrayOfGets = [];

        if((argURL != null) || (argURL.length != 0)){
            axios.all(getArrayOfGetsForListOfPolice(argURL, argCompanyId ,argIdToken, argUserId )).then(function(responses){
                resolve(responses[0].data);
            }, function(err) {
                console.log("Farshid some error occured on getting list of Storage " + err.message +  " the URL is " + argURL );
                reject(err);
            });
        }
    });

    return returnPromise;
}


